import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { gsap } from 'gsap'
//import planetTexture from '../static/textures/01-World.jpg'
import americaTexture from '../static/textures/02-Americas.jpg'
import europeTexture from '../static/textures/03-Europe.jpg'
import africaTexture from '../static/textures/04-MiddleEast-NorthAfrica.jpg'
import ksaTexture from '../static/textures/05-KSA.jpg'
import asiaTexture from '../static/textures/06-Asia.jpg'
import oceaniaTexture from '../static/textures/07-Oceania.jpg'
import pinTexture from '../static/textures/pin.png'
import * as dat from 'dat.gui'
import fontJson from '../static/fonts/helvetiker_regular.typeface.json'


export default class WORLD {
    constructor(options) {
        this.container = document.getElementById(options.container)
        this.init()
        this.defaultEvents()

        this.content()
        this.customEvents()
        this.render()
    }

    init() {
        this.width = this.container.offsetWidth
        this.height = this.container.offsetHeight

        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        })
        this.renderer.setSize(this.width, this.height)
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        this.container.appendChild(this.renderer.domElement)

        this.scene = new THREE.Scene()

        this.camera = new THREE.PerspectiveCamera(70, this.width / this.height, 0.0001, 10000)
        this.camera.position.z = 2

        //this.camera.fov = 2 * Math.atan((this.height / 2) / 600) * (180 / Math.PI)
        this.camera.aspect = this.width / this.height
        this.camera.updateProjectionMatrix()

        this.controls = new OrbitControls(this.camera, this.renderer.domElement)
        this.controls.enableDamping = true
        this.controls.enablePan = false
        this.controls.enableZoom = false

        this.clock = new THREE.Clock()
    }

    defaultEvents() {
        window.addEventListener('resize', () => {
            this.width = this.container.offsetWidth
            this.height = this.container.offsetHeight
            this.renderer.setSize(this.width, this.height)
            this.camera.aspect = this.width / this.height
            this.camera.updateProjectionMatrix()
        })
    }

    content() {
        this.isHover = false
        this.isRotating = false
        this.raycaster = new THREE.Raycaster()
        this.mouse = new THREE.Vector2()

        this.textureLoader = new THREE.TextureLoader()
        this.fontLoader = new THREE.FontLoader()

        this.poi = [{
                id: 'america',
                label: 'America',
                texture: this.textureLoader.load(americaTexture),
                lat: 40.7128,
                lng: -74.0060,
                url: '#'
            },
            {
                id: 'europe',
                label: 'Europe',
                texture: this.textureLoader.load(europeTexture),
                lat: 41.9028,
                lng: 12.4964,
                url: '#'
            }, {
                id: 'middle',
                label: 'Middle East North Africa',
                texture: this.textureLoader.load(africaTexture),
                lat: 30.0444,
                lng: 31.2357,
                url: '#'
            },
            {
                id: 'ksa',
                label: 'KSA',
                texture: this.textureLoader.load(ksaTexture),
                lat: 23.8859,
                lng: 45.0792,
                url: '#'
            }, {
                id: 'asia',
                label: 'Asia',
                texture: this.textureLoader.load(asiaTexture),
                lat: 34.0479,
                lng: 100.6197,
                url: '#'
            },
            {
                id: 'oceania',
                label: 'Oceania',
                texture: this.textureLoader.load(oceaniaTexture),
                lat: -22.7359,
                lng: 140.0188,
                url: '#'
            }
        ]
        this.poiElements = []

        this.planetTexture = new THREE.TextureLoader().load('./textures/01-World.jpg')
            //console.log(this.planetTexture)
            //this.planetTexture.needsUpdate = true
        this.planetGeometry = new THREE.SphereBufferGeometry(1, 128, 128);
        this.planetMaterial = new THREE.MeshBasicMaterial({ map: this.planetTexture, wireframe: false })
            // this.planetMaterial.needsUpdate = true
        this.planet = new THREE.Mesh(this.planetGeometry, this.planetMaterial)

        this.scene.add(this.planet)

        this.poiRotation = { x: 0, y: 0, z: 0 }

        const font = this.fontLoader.parse(JSON.parse(fontJson))

        for (let i in this.poi) {

            const poi = this.poi[i]
            const pos = this.convertPosFromLatLngRad(poi.lat, poi.lng, 1.05)

            const poiGroup = new THREE.Group()

            poiGroup.position.set(pos.x, pos.y, pos.z)
            poiGroup.rotation.y = Math.PI
            poiGroup.userData.id = poi.id
            poiGroup.userData.label = poi.label

            this.planet.add(poiGroup)
            this.poiElements.push(poiGroup)

            const trigger = new THREE.Mesh(
                new THREE.PlaneGeometry(0.12, 0.12),
                new THREE.MeshBasicMaterial({ color: 0x000000, side: THREE.DoubleSide, transparent: true, opacity: 0 })
            )
            trigger.position.z = -0.01
            trigger.userData.type = 'trigger'
            trigger.userData.planeTexture = poi.texture
            poiGroup.add(trigger)


            const pin = new THREE.Mesh(
                new THREE.CircleGeometry(0.03, 32),
                new THREE.MeshBasicMaterial({
                    color: 0x000000,
                    side: THREE.DoubleSide,
                })
            )

            poiGroup.add(pin)

            const pinWhite = new THREE.Mesh(
                new THREE.CircleGeometry(0.007, 32),
                new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    side: THREE.DoubleSide,
                })
            )
            pinWhite.position.z = -0.001

            pin.add(pinWhite)


            const linePoints = [];
            linePoints.push(new THREE.Vector3(-0.05, 0, 0));
            linePoints.push(new THREE.Vector3(-0.15, 0, 0));

            const lineGeometry = new THREE.BufferGeometry().setFromPoints(linePoints);

            const line = new THREE.Line(lineGeometry, new THREE.LineBasicMaterial({
                color: 0x000000
            }));

            poiGroup.add(line)

            const textLocation = new THREE.Mesh(new THREE.TextBufferGeometry(
                poi.label.toUpperCase(), {
                    font: font,
                    size: 0.0175,
                    height: 0.0015
                }
            ), new THREE.MeshBasicMaterial({ color: 0x000000 }))
            textLocation.rotation.y = Math.PI
            textLocation.position.x = -0.17
            textLocation.position.y = 0.015
            poiGroup.add(textLocation)

            const textBalich = new THREE.Mesh(new THREE.TextBufferGeometry(
                'BALICH WONDER STUDIO', {
                    font: font,
                    size: 0.0175,
                    height: 0.0015
                }
            ), new THREE.MeshBasicMaterial({ color: 0x000000 }))
            textBalich.rotation.y = Math.PI
            textBalich.position.x = -0.17
            textBalich.position.y = -0.015
            poiGroup.add(textBalich)
            poiGroup.lookAt(0, 0, 0)
        }

        this.navigation()
            //this.debug()
    }

    convertPosFromLatLngRad(lat, lng, rad) {
        const phi = (90 - lat) * (Math.PI / 180)
        const theta = (lng + 180) * (Math.PI / 180)

        let x = rad * -(Math.sin(phi) * Math.cos(theta))
        let y = rad * Math.cos(phi)
        let z = rad * (Math.sin(phi) * Math.sin(theta))


        return { x: x, y: y, z: z }
    }

    customEvents() {
        this.container.addEventListener('mousemove', (event) => {
            this.mouse.x = (event.layerX / this.width) * 2 - 1
            this.mouse.y = -(event.layerY / this.height) * 2 + 1
        }, false);
    }

    navigation() {
        const that = this
        const $ = jQuery
        let elements = ''
        for (let i in this.poiElements) {
            elements += '<li data-value="' + this.poiElements[i].userData['id'] + '"><span>' + this.poiElements[i].userData.label + '</span></li>'
        }
        $('body').append('<div id="side-nav" data-nav="world"><ul>' + elements + '</ul></div>')

        $('[data-nav="world"] li').on('click', (e) => {
            this.isRotating = true
            that.rotateTo($(e.currentTarget).data('value'))
            setTimeout(() => {
                this.isRotating = false
            }, 2000)
            return false
        }).eq(0).trigger('click')

    }

    debug() {
        this.gui = new dat.GUI()
        this.gui.add(this.planet.rotation, 'x').min(-10).max(10).step(0.01).name('rotation x')
        this.gui.add(this.planet.rotation, 'y').min(-10).max(10).step(0.01).name('rotation y')
        this.gui.add(this.planet.rotation, 'z').min(-10).max(10).step(0.01).name('rotation z')
    }

    rotateTo(area) {

        /**
         * Camera Rotations
         */
        // const rotations = {
        //     'america': {
        //         x: -0.8015324544362311,
        //         y: 0.2124473107845749,
        //         z: 0.21442123712692215
        //     },
        //     'europe': {
        //         x: -1.8700686919677898,
        //         y: 0.8181857657963304,
        //         z: 1.9707259746701606
        //     },
        //     'middle': {
        //         x: -2.2877252585086914,
        //         y: 0.8051433658721225,
        //         z: 2.4505517739051257
        //     },
        //     'ksa': {
        //         x: -2.536942224109582,
        //         y: 0.6921695749745733,
        //         z: 2.7262539367525
        //     },
        //     'asia': {
        //         x: -2.5412278961481727,
        //         y: -0.13760848232820283,
        //         z: -3.0479476885314694
        //     },
        //     'oceania': {
        //         x: 2.545656352303529,
        //         y: -0.7496828522946658,
        //         z: 2.7087042707397564
        //     }
        // }

        /**
         * Planet Rotations
         */
        const rotations = {
            'america': {
                x: 0.69,
                y: -0.31,
                z: 0
            },
            'europe': {
                x: 0.8,
                y: -1.8,
                z: 0
            },
            'middle': {
                x: 0.5,
                y: -2.1,
                z: 0
            },
            'ksa': {
                x: 0.43,
                y: -2.33,
                z: 0
            },
            'asia': {
                x: 0.6,
                y: -3.35,
                z: 0
            },
            'oceania': {
                x: -0.2,
                y: -4,
                z: 0
            }
        }

        gsap.to(this.planet.rotation, {
            x: rotations[area].x,
            y: rotations[area].y,
            z: rotations[area].z,
        });

    }

    getRotation() {
        console.log(this.camera.rotation)
    }

    render() {

        const elapsedTime = this.clock.getElapsedTime()

        this.isHover = false
        this.planet.material.map = this.planetTexture
        document.querySelector('body').style.cursor = 'auto'


        // this.raycaster.setFromCamera(this.mouse, this.camera)
        // const intersects = this.raycaster.intersectObjects(this.scene.children, true)
        // if (intersects.length) {
        //     for (let i in intersects) {
        //         if (intersects[i].object.userData.type === 'trigger') {
        //             this.isHover = true
        //             document.querySelector('body').style.cursor = 'pointer'
        //             this.planet.material.map = intersects[i].object.userData.planeTexture

        //         }
        //     }
        // }


        if (!this.isHover && !this.isRotating) {
            this.planet.rotation.y += 0.001
        }

        this.controls.update()
        this.renderer.render(this.scene, this.camera)
        window.requestAnimationFrame(this.render.bind(this))
    }

}

window.WORLD = new WORLD({
    container: 'webgl'
})